import {
    Attribute,
    BelongsTo,
    JsonApiDatastore,
    JsonApiModel,
    JsonApiModelConfig
} from 'angular2-jsonapi'
import { LocalDateConverter } from '../core/converters/local-date.converter'
import { EmpresaQueVendeComCartoes } from './empresa-que-vende-com-cartoes.model'
import { OperadoraDeMaquina } from './operadora-de-maquina.model'
import * as XLSX from 'xlsx';

@JsonApiModelConfig({
    type: 'exportacoes',
})
export class Exportacao extends JsonApiModel {
    @Attribute() exportaVendas: boolean
    @Attribute() exportaRecebimentos: boolean
    @Attribute() exportaAntecipacoes: boolean
    @Attribute({ converter: new LocalDateConverter() })
    inicio: Date
    @Attribute({ converter: new LocalDateConverter() })
    fim: Date
    @Attribute() apuraTaxaDeRecebimentos: boolean
    @Attribute() apuraTaxaDeVendas: boolean
    @Attribute() aglutinaPorMes: boolean
    @Attribute() apuraLiquidoDasVendas: boolean
    @Attribute() apuraBrutoDosRecebimentos: boolean
    @Attribute() apuraDebito: boolean
    @Attribute() apuraCredito: boolean
    @Attribute() dados: string
    @Attribute() avisos: string[]
    @BelongsTo() empresaQueVendeComCartoes: EmpresaQueVendeComCartoes
    @BelongsTo() operadora: OperadoraDeMaquina

    constructor(_datastore: JsonApiDatastore, data?: any) {
        const agora = new Date()
        const fim = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() - 1)
        const inicio = new Date(agora.getFullYear(), agora.getMonth(), fim.getDate() - 7)
        const defaults = {
            exportaVendas: false,
            exportaRecebimentos: false,
            exportaAntecipacoes: false,
            apuraTaxaDeRecebimentos: true,
            apuraTaxaDeVendas: false,
            aglutinaPorMes: false,
            apuraLiquidoDasVendas: false,
            apuraBrutoDosRecebimentos: false,
            apuraDebito: true,
            apuraCredito: true,
            avisos: [],
            inicio,
            fim,
        }

        data.attributes = Object.assign(defaults, data.attributes)

        super(_datastore, data)
    }

    possuiDados() {
        return !!this.dados
    }

    arrayDados(dados) {
        let array = dados.split('\r\n');
        let newArray = [];

        newArray.push([
            ['Código Lançamento Automático'],
            ['Código Conta Débito'],
            ['Código Conta Crédito'],
            ['Data Lançamento'],
            ['Valor Lançamento'],
            ['Código Histórico Padrão'],
            ['Descrição Histórico'],
            ['Número documento']
        ]);

        for (let i in array) {
            let newItem = array[i].slice(1, -1);
            newArray.push(newItem.split('","'));
        }

        return newArray;
    }

    s2ab(s) {
        let buf = new ArrayBuffer(s.length);
        let view = new Uint8Array(buf);
        for (let i = 0; i < s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    }

    criarArquivo(formato: string) {
        if (!this.possuiDados()) {
            throw new Error('Não há dados para gerar o arquivo.');
        }

        let options = this.getType(formato);

        let blob =
            formato == 'XLS' || formato == 'XLSX'
                ? this.blobXLS(this.dados, options)
                : this.blobTXT(this.dados, options);

        let nome = this.gerarNomeDoArquivo(formato);

        try {
            return new File([blob], nome, options)
        } catch (e) {
            // fallback para o PHD
            if (e.message === 'Illegal constructor') {
                const file: any = blob

                file.lastModified = new Date().getTime()
                file.name = nome
                file.fileName = nome

                return file as File
            }
        }
    }

    blobTXT(dados, options) {
        return new Blob([dados], options);
    }

    blobXLS(dados, options) {
        let wb = XLSX.utils.book_new();

        let newDados = this.arrayDados(dados);
        let ws = XLSX.utils.aoa_to_sheet(newDados);

        XLSX.utils.book_append_sheet(wb, ws, 'Aba1');

        let data = XLSX.write(wb, { type: 'base64' });

        return new Blob([this.s2ab(atob(data))], options);
    }

    getType(formato) {
        let type = '';

        if (formato == 'TXT') {
            type = 'text/plain';
        } else if (formato == 'XLS') {
            type = 'application/vnd.ms-excel';
        } else if(formato == 'XLSX') {
            type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }

        return { type };
    }

    gerarNomeDoArquivo(formato) {
        const operadora = this.operadora ? `_${this.operadora.codename}` : ''

        let tipoVenda
        if (this.apuraCredito && this.apuraDebito) {
            tipoVenda = ''
        } else if (this.apuraCredito) {
            tipoVenda = '_Crédito'
        } else if (this.apuraDebito) {
            tipoVenda = '_Débito'
        }

        let tipoTransacao
        if (this.exportaAntecipacoes && this.exportaRecebimentos && this.exportaVendas) {
            tipoTransacao = ''
        } else if (this.exportaAntecipacoes) {
            tipoTransacao = '_antecipacoes'
        } else if (this.exportaRecebimentos) {
            tipoTransacao = '_recebimentos'
        } else if (this.exportaVendas) {
            tipoTransacao = '_vendas'
        }

        const empresa = `_${this.empresaQueVendeComCartoes.empresa.idExterno}`

        return `Cartao${operadora}${tipoVenda}${tipoTransacao}${empresa}.${formato.toLowerCase()}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/exportacao.model.ts